//import { TokenUsageLegendLabel } from './TokenUsageLegendLabel';

interface ITokenUsageLegendItem {
    name: string;
    usageCount: number;
    //items: TokenUsageViewDetails[];
    color: string;
}

export const TokenUsageLegendItem: React.FC<ITokenUsageLegendItem> = ({ name, usageCount, color /*, items,*/ }) => {
    return (
        <div className={`flex items-center`}>
            {/* <Popover
                openOnHover
                mouseLeaveDelay={0}
                positioning={{
                    position: 'below',
                    align: 'start',
                }}
                withArrow
                appearance="inverted"
            >
                <PopoverTrigger>
                    <div
                        key={color}
                        style={{
                            backgroundColor: color,
                            // height: tokens.spacingVerticalMNudge,
                            // width: tokens.spacingHorizontalMNudge,
                        }}
                        className={`h-2 w-2 mr-2`}
                    />
                </PopoverTrigger>
                <PopoverSurface>
                    {items.length > 0
                        ? items.map((details) => {
                            return <TokenUsageLegendLabel key={details.legendLabel} details={details} />;
                        })
                        : 'No usage'}
                    {
                        // TODO: [Issue #150, sk#2106] Remove this once core team finishes work to return token usage.
                        name === 'Response Generation' && `(Planner usage coming soon)`
                    }
                </PopoverSurface>
            </Popover> */}
            <div
                key={color}
                style={
                    {
                        // backgroundColor: color,
                        // height: tokens.spacingVerticalMNudge,
                        // width: tokens.spacingHorizontalMNudge,
                    }
                }
                className={`h-2 w-2 mr-2 ${color}`}
            />
            <span className="mr-2">{`${name} (${usageCount})`}</span>
        </div>
    );
};
